{
  "aiGeneratedAnswer": "AI generovaná odpověď",
  "allCategories": "Všechny kategorie",
  "appliedFiltersToCurrentSearch": "Použité filtry pro aktuální hledání",
  "apply": "Použít",
  "applyFilters": "Použít filtry",
  "autocompleteOptionsFound_few": "Nalezeny {{count}}{{label}} možnosti automatického dokončování.",
  "autocompleteOptionsFound_many": "Nalezeno {{count}}{{label}} možností automatického dokončování.",
  "autocompleteOptionsFound_one": "Nalezena {{count}}{{label}} možnost automatického dokončování.",
  "autocompleteOptionsFound_other": "Nalezeno {{count}}{{label}} možností automatického dokončování.",
  "autocompleteSuggestion": "návrh automatického doplňování: {{suggestion}}",
  "autocompleteSuggestionsFound_few": "Nalezeny {{count}} návrhy automatického dokončování.",
  "autocompleteSuggestionsFound_many": "Nalezeno {{count}} návrhů automatického dokončování.",
  "autocompleteSuggestionsFound_one": "Nalezen {{count}} návrh automatického dokončování.",
  "autocompleteSuggestionsFound_other": "Nalezeno {{count}} návrhů automatického dokončování.",
  "basedOnYourDevice": " (na základě vašeho zařízení)",
  "basedOnYourInternetAddress": " (na základě vaší IP adresy)",
  "categoriesText_few": "Následující kategorie přinesla výsledky pro – <strong>{{query}}</strong>",
  "categoriesText_one": "Následující kategorie přinesly výsledky pro – <strong>{{query}}</strong>",
  "categoriesText_other": "Následujících kategorií přineslo výsledky pro – <strong>{{query}}</strong>",
  "clearAll": "Vyčistit vše",
  "clearMinAndMax": "Vymazat min a max",
  "clearTheRangeToSelectOptions": "Vymažte rozsah pro výběr možností.",
  "clearTheSearchBar": "Vymažte vyhledávací lištu",
  "conductASearch": "Provést vyhledávání",
  "currentLocation": "Aktuální poloha",
  "didYouMean": "Mysleli jste <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Pokud jsou dostupné výsledky automatického doplnění, použijte šipky nahoru/dolů pro výběr a Enter pro potvrzení.",
  "feedback": "Zpětná vazba",
  "filterGroupSearchInputLabel": "Hledat možnosti {{title}}",
  "invalidRange": "Neplatný rozsah",
  "max": "Max",
  "min": "Min",
  "navigateToTheNextResultsPage": "Přejděte na další stránku výsledků",
  "navigateToThePreviousResultsPage": "Přejděte na stránku předchozích výsledků",
  "noAutocompleteOptionsFound": "Nenalezeny žádné možností automatického doplňování.",
  "noAutocompleteSuggestionsFound": "Nenalezeny žádné návrhy automatického doplňování.",
  "noResultsFoundIn": "V {{currentVerticalLabel}} nebyly nalezeny žádné výsledky.",
  "paginationPage": "stránka {{pageNumber}}",
  "pagination": "Stránkování",
  "readMoreAbout": "Přečíst si více o <a>{{name}}</a>",
  "recentSearch": "nedávné vyhledávání: {{query}}",
  "recentSearchesFound_few": "Nalezena {{count}} nedávná hledání.",
  "recentSearchesFound_many": "Nalezeno {{count}} nedávných hledání.",
  "recentSearchesFound_one": "Nalezeno {{count}} nedávné hledání.",
  "recentSearchesFound_other": "Nalezeno {{count}} nedávných hledání.",
  "removeFilter": "Odebrat filtr „{{displayName}}“",
  "resultPreview": "náhled výsledků: {{value}}",
  "resultPreviewsFound_few": "Nalezeny {{count}} náhledy výsledků.",
  "resultPreviewsFound_many": "Nalezeno {{count}} náhledů výsledků.",
  "resultPreviewsFound_one": "Nalezen {{count}} náhled výsledku.",
  "resultPreviewsFound_other": "Nalezeno {{count}} náhledů výsledků.",
  "resultsCountText_few": "{{count}} výsledky",
  "resultsCountText_many": "{{count}} výsledků",
  "resultsCountText_one": "{{count}} výsledek",
  "resultsCountText_other": "{{count}} výsledků",
  "resultsCountWithPaginationText": "{{paginateStart}} – {{paginateEnd}} z {{resultsCount}} výsledků",
  "searchHere": "Hledejte zde…",
  "showingAllInstead": "Místo toho zobrazujeme všechny {{currentVerticalLabel}}.",
  "showLess": "Zobrazit méně",
  "showMore": "Zobrazit více",
  "sources_few": "Zdroje ({{count}})",
  "sources_many": "Zdroje ({{count}})",
  "sources_one": "Zdroj",
  "sources_other": "Zdroje ({{count}})",
  "submitSearch": "Odeslat vyhledávání",
  "suggestionResultsCount_few": "{{label}} – {{count}} výsledky",
  "suggestionResultsCount_many": "{{label}} – {{count}} výsledků",
  "suggestionResultsCount_one": "{{label}} – {{count}} výsledek",
  "suggestionResultsCount_other": "{{label}} – {{count}} výsledků",
  "thankYouForYourFeedback": "Děkujeme za vaši zpětnou vazbu!",
  "thisAnsweredMyQuestion": "Toto odpovědělo na mou otázku",
  "thisDidNotAnswerMyQuestion": "Toto neodpovědělo na mou otázku",
  "unselectAnOptionToEnterInARange": "Zrušte výběr možnosti, abyste mohli zadat rozsah.",
  "updateYourLocation": "Aktualizujte svou polohu",
  "useCurrentLocation": "Použít aktuální polohu",
  "useMyLocation": "Použít mou polohu",
  "viewAll": "Zobrazit vše",
  "viewDetails": "Zobrazit podrobnosti"
}
